import { ISiteWalkMedia, IUploadFileForm } from '@api/models';
import { uploadFileInSiteWalk } from '@api/services/sitewalk-gui.service';
import { Button } from '@components/buttons';
import FileUploadPreview from '@components/FileUploadPreview/FileUploadPreview';
import DragAndDropFileUpload from '@components/FormFields/DragAndDropFileUpload';
import { HelpText } from '@hyperflake/react-ui-library';
import { Drawer } from '@library/drawer';
import { FormHelperText, Label } from '@library/forms';
import { CircularProgress } from '@library/loaders/components';
import { ErrorMessage, Form, Formik } from 'formik';
import { getMediaType } from 'modules/site-walk-gui/helper/floor-plan-gui.utils';
import { toast } from 'react-toastify';
import * as Yup from 'yup';

interface FileUploadDrawerProps {
    show: boolean;
    onClose: () => void;
    clientId: string; // 👈 add these
    projectId: string; // 👈
    siteWalkMediaId: string;
    onSave: (updatedFloorPlanMedia: ISiteWalkMedia) => void;
}
const initialValues = {
    file: null as File | null, // single file, not array
};

const AddDocumentSchema = Yup.object({
    // file: Yup.array().min(1, 'Please select at least one file').required('Please select at least one file'),
    // name: Yup.string().trim().required('This field is required'),
});

const FileUploadDrawer = (props: FileUploadDrawerProps) => {
    const { show, onClose, clientId, projectId, siteWalkMediaId, onSave } = props;

    const handleSubmit = async (values: { file: File | null }) => {
        try {
            if (!values.file) return;

            const formData = new FormData();
            formData.append('file', values.file);
            formData.append('mediaType', getMediaType(values.file));

            const updatedFloorPlanMedia = await uploadFileInSiteWalk(clientId, projectId, siteWalkMediaId, formData);

            onSave?.(updatedFloorPlanMedia);

            toast.success('File uploaded successfully.');
            onClose();
        } catch (err: any) {
            if (err?.message === 'canceled' || err?.code === 'ERR_CANCELED') return;
            toast.error(err?.data?.message || 'Some error occurred, please try again.');
        }
    };

    return (
        <Drawer open={show} onClose={onClose}>
            <div className="flex flex-col h-[calc(100dvh-3rem)]">
                <h4>Upload File</h4>

                <div className="mt-2">
                    <Formik
                        initialValues={initialValues}
                        validationSchema={AddDocumentSchema}
                        enableReinitialize
                        onSubmit={handleSubmit}
                    >
                        {({ values, setFieldValue, isSubmitting, errors }) => {
                            console.log('errors', errors);

                            return (
                                <Form id="uploadFileForm">
                                    <div className="">
                                        <DragAndDropFileUpload
                                            text="Browse JPG/PNG/MP4"
                                            accept={{
                                                'image/*': ['.jpeg', '.jpg', '.png'],
                                                'video/*': ['.mp4'],
                                            }}
                                            onChange={(files) => setFieldValue('file', files[0])}
                                        />
                                    </div>
                                    <HelpText variant="error">
                                        <ErrorMessage name="file" />
                                    </HelpText>

                                    <div className="mt-4">
                                        {values.file && (
                                            <div>
                                                <FileUploadPreview
                                                    name={values.file.name}
                                                    size={values.file.size}
                                                    onCancel={() => setFieldValue('file', null)}
                                                />
                                            </div>
                                        )}
                                    </div>
                                    <div className="mt-auto">
                                        <div className="flex gap-4 mt-2 pb-4">
                                            <Button type="button" color="secondary" onClick={onClose}>
                                                Cancel
                                            </Button>

                                            {/* ✅ Submit button re-enabled */}
                                            <Button type="submit" form="uploadFileForm" disabled={isSubmitting}>
                                                {isSubmitting ? (
                                                    <CircularProgress size={20} color={'inherit'} />
                                                ) : (
                                                    'Upload'
                                                )}
                                            </Button>
                                        </div>
                                    </div>
                                </Form>
                            );
                        }}
                    </Formik>
                </div>
            </div>
        </Drawer>
    );
};

export default FileUploadDrawer;
